<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AqpwYx/tc-custom/9780544290150.jpg?1734325134157" alt="This image is the cover for the book Heart You Carry Home"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heart You Carry Home
      </h1>
      <p class="bookDescription body article font2">
        <b>A novel about men returning from war, and the women who love them, by “a young writer full of energy and promise” (Jennifer Egan, author of <i>Manhattan Beach</i>).</b><br/>  <br/> Becca Keller is no stranger to the way war can change a man. Her Vietnam veteran father, King, suffered after his service, and as a result played only a limited role in his daughter’s life. Now Becca is marrying Ben, who is also just back from battle—and her mother, convinced that Becca is making the same mistakes she did, boycotts the wedding.<br/>  <br/> Ben does indeed seem different after his second tour, and only days after she marries him, he turns dangerous. Desperate, Becca turns to her father for help. But he is heading west with his motorcycle buddies—out to a place they call Kleos, a mysterious desert compound ruled over by a guru-like commanding officer. It serves as a refuge for some soldiers, but it might be the death of others.<br/>  <br/> There, Becca will be faced with the possibility that she may not know the real damage in her loved ones’ hearts. In finally seeing her father’s demons, she might just be able to start a journey back to peace with her husband. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Miller
      </h2>
      
      <p class="authorDescription body article">Jennifer Miller, the author of <I>Inheriting the Holy Land: An American&rsquo;s Search for Hope in the Middle East</I>, holds a BA from Brown University, an MS in journalism from Columbia, and an MFA in fiction writing from Columbia. Her work has been published in the<I> New York Times</I>, <I>Marie Claire</I>, <I>Men&rsquo;s Health</I>, the <I>Christian Science Monitor</I>, Salon.com, and others.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79f37639